import { AxiosError } from 'axios'
import { apiUrls, roles, settings } from 'consts'
import { axiosPut } from 'shared/api/axios'
import { setSettingsValue } from 'shared/components/App/Auth'
import displayError from 'shared/utils/displayError'
import hasAnyRole from 'shared/utils/hasAnyRole'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const isSuperAdmin: boolean = hasAnyRole([roles.superAdmin])


  const data: {} = {
    [settings.pageSizeDevices]: props.data.pageSize.id,
    [settings.pageSizeUsers]: props.data.pageSizeUsers.id,
    [settings.pageSizeSites]: props.data.pageSizeSites.id,
    [settings.pageSizeCostCenters]: props.data.pageSizeCostCenters.id,
    ...(isSuperAdmin && {
      [settings.pageSizeSuperadmins]: props.data.pageSizeSuperadmins.id,
    }),
  }

  props.setShowOverlay(true)

  const catchFunc = (err: AxiosError) => {
    displayError({
      errorMessage: err?.response?.data?.message ?? 'An error has occurred.',
      setShowOverlay: props.setShowOverlay,
    })
  }

  //update settings on the server and update Store
  response = await axiosPut(apiUrls.settings + '/' + apiUrls.actionBulkUpdate, data, catchFunc)

  if (response) {
    setSettingsValue(settings.pageSizeDevices, props.data.pageSize.id)
    setSettingsValue(settings.pageSizeUsers, props.data.pageSizeUsers.id)
    setSettingsValue(settings.pageSizeSites, props.data.pageSizeSites.id)
    setSettingsValue(settings.pageSizeCostCenters, props.data.pageSizeCostCenters.id)
    if (isSuperAdmin) {
      setSettingsValue(settings.pageSizeSuperadmins, props.data.pageSizeSuperadmins.id)
    }
  }

  return true
}

export default submitForm
